import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function PlaintiffDefenseFeeForm({ location }) {
  console.log('PlaintiffDefenseFeeForm rendered: ', location)

  let init = {
    lastName: '',
    firstName: '',
    middleName: '',
    documentId: '',
    paidDateFrom: '',
    paidDateTo: '',
    greaterThan: '',
    plaintiffCounsel: [],
    defenseCounsel: [],
    orderBy: '1',
    orderDir: 'ASC'
  }

  const navigate = useNavigate()
  init = initialFormValues('PlaintiffDefenseFeeForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState({})

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  async function submitSearch() {
    console.log('PlaintiffDefenseFeeForm.submitSearch', inputs)

    let validInput = false
    for (let input in inputs) {
      if (input !== 'sortBy' && inputs[input]) {
        if (inputs[input].length && inputs[input].length > 0) {
          console.log(input)
          validInput = true
        }
      }
    }
    if (!validInput) {
      return setFormFeedback({ noInput: <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{display: 'block', textAlign: 'center', margin: 'auto'}}>At least one input value is required</Alert></td></tr>})
    }
    setFormFeedback({})
    submitFormValues('PlaintiffDefenseFeeForm', navigate, inputs, 'plaintiff.defense_fee_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText={'Plaintiff Defense Fee Report'} />
            {formFeedback.noInput}
            <tbody>
              <TextInput label='Last Name' name='lastName' handleInputChange={handleInputChange} defaultValue={inputs.lastName} />
              <TextInput label='First Name' name='firstName' handleInputChange={handleInputChange} defaultValue={inputs.firstName} />
              <TextInput label='Middle Name' name='middleName' handleInputChange={handleInputChange} defaultValue={inputs.middleName} />
              <TextInput label='Document ID' name='documentId' handleInputChange={handleInputChange} defaultValue={inputs.documentId} />
              <DateRangeInput label='Paid Date' name='paidDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.paidDateFrom} defaultValueTo={inputs.paidDateTo} />
              <TextInput label='Amount Paid Greater Than' name='greaterThan' handleInputChange={handleInputChange} defaultValue={inputs.greaterThan} />
              <CustomSelectListInput label='Plaintiff Counsel' handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' multiple={true} defaultValue={inputs.plaintiffCounsel} />
              <CustomSelectListInput label='Defense Counsel' handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' multiple={true} defaultValue={inputs.defenseCounsel} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
